import React from "react";
import "../css/Gallery.css";

const Gallery = () => {
  return (
    <div className="gallery6">

      {/* ================= HERO ================= */}
      <section className="g6-hero">
        <h1>Gallery</h1>
        <p>Spaces. Movement. Training.</p>
      </section>

      {/* ================= IMAGE FIELD ================= */}
      <section className="g6-field">

        <div className="g6-grid">

          <img src="https://images.pexels.com/photos/841130/pexels-photo-841130.jpeg" alt="" />
          <img src="https://images.pexels.com/photos/3823039/pexels-photo-3823039.jpeg" alt="" />
          <img src="https://images.pexels.com/photos/1552249/pexels-photo-1552249.jpeg" alt="" />

          <img src="https://images.pexels.com/photos/1954524/pexels-photo-1954524.jpeg" alt="" />
          <img src="https://images.pexels.com/photos/3757376/pexels-photo-3757376.jpeg" alt="" />
          <img src="https://images.pexels.com/photos/6453399/pexels-photo-6453399.jpeg" alt="" />

          <img src="https://images.pexels.com/photos/4327033/pexels-photo-4327033.jpeg" alt="" />
          <img src="https://images.pexels.com/photos/1552249/pexels-photo-1552249.jpeg" alt="" />

          <img src="https://images.pexels.com/photos/3823063/pexels-photo-3823063.jpeg" alt="" />
          <img src="https://images.pexels.com/photos/841130/pexels-photo-841130.jpeg" alt="" />
          <img src="https://images.pexels.com/photos/3757376/pexels-photo-3757376.jpeg" alt="" />

        </div>

      </section>

    </div>
  );
};

export default Gallery;
